// covered-by: frontends/carrie/src/routes/settings/routes/knowledge-database/components/__tests__/SourcesPanel.test.tsx
import { ChatCircleText } from "@phosphor-icons/react";
import { Flex, Link as RadixLink, Text } from "@radix-ui/themes";
import { Link as RouterLink } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { ASK_V2_CHAT_PATH } from "../../../../../ask-v2/paths";
import {
  KnowledgeSourceInteraction,
  type KnowledgeSourceResult,
} from "../../../../../utils/parsers/knowledge";

/**
 * Where a source came from when no person uploaded it on this page: the chat
 * its document was attached in. A source filed from a review is otherwise
 * indistinguishable from a manual upload, and an admin wondering why it is
 * here has no way back to the conversation that produced it.
 */
export function SourceOriginLink({
  source,
}: {
  source: Pick<KnowledgeSourceResult, "_id" | "interactionRef" | "file">;
}) {
  const { t } = useTranslation("ui");
  const ref = source.interactionRef;
  if (ref?.kind !== KnowledgeSourceInteraction.ASK_PUNTT_CHAT || !ref.id) {
    return null;
  }
  return (
    <Flex align="center" gap="1" mt="1">
      <ChatCircleText size={12} aria-hidden="true" />
      <RadixLink size="1" asChild>
        {/* why-not: a raw href drops the router basepath, so on an epic
            (/<stage>/...) it opened ask-epic.puntt.ai/ask-puntt/<id>: Not Found. */}
        <RouterLink
          to={ASK_V2_CHAT_PATH}
          params={{ chatId: ref.id }}
          aria-label={t("settings.sourcesPanel.openUploadChatFor", {
            fileName: source.file.fileName,
          })}
          data-testid={`knowledge-sources-origin-chat-${source._id}`}
        >
          <Text size="1">{t("settings.sourcesPanel.uploadedInChat")}</Text>
        </RouterLink>
      </RadixLink>
    </Flex>
  );
}
